import { render, staticRenderFns } from "./FlatPicker.vue?vue&type=template&id=646bf844&"
import script from "./FlatPicker.vue?vue&type=script&lang=ts&"
export * from "./FlatPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports